import type { FC } from "react"
import type { WithLinkFragment } from "~/contentful"
import type { SerializeFrom } from "@remix-run/node"
import classNames from "classnames"

interface Props {
  link: SerializeFrom<WithLinkFragment> | null
}

const SiteBanner: FC<Props> = ({ link }) => {
  if (!link?.blurb) {
    return null
  }

  const backgroundColor = link?.backgroundColor

  const textColor = link?.textColor

  return (
    <div
      className={classNames(
        "relative z-20 flex w-full items-center justify-center text-center text-sm md:text-base",
        {
          "bg-blue-dark-500": !backgroundColor
        }
      )}
      style={{
        backgroundColor: backgroundColor ?? undefined
      }}
    >
      <a
        className={classNames(
          "-ml-6 block w-full px-6 py-4 text-white md:-ml-0",
          { "text-white": !textColor }
        )}
        href={link.url ?? ""}
        style={{
          color: textColor ?? undefined
        }}
      >
        {link.blurb}
      </a>
    </div>
  )
}

export default SiteBanner
